/* ==========================================================================
   Tiroir de panier maison, repris de StowLadder.

   Remplace une application payante. Rien ici n'est exotique : Shopify expose
   le panier depuis toujours (`/cart/add.js`, `/cart/change.js`), et l'API de
   rendu de section renvoie le HTML deja calcule.

   Principe : le JavaScript ne calcule AUCUN montant. Il envoie la
   modification, puis redemande a Shopify le HTML complet du tiroir. Les
   totaux, les remises et les taxes restent du cote qui fait foi. Un total
   recalcule dans le navigateur finit toujours par diverger de la caisse, et
   sur un site qui vend la transparence des chiffres ce serait le pire des
   bugs.

   Degradation : si le script ne charge pas, le formulaire de la fiche
   produit reste un formulaire HTML classique qui poste vers /cart. Le client
   arrive sur la page panier. Plus lent, jamais casse.
   ========================================================================== */

(function () {
  'use strict';

  var SECTION = 'pl-cart-drawer';

  var racine = document.querySelector('[data-pl-cart]');
  if (!racine) { return; }

  var panneau = racine.querySelector('[data-pl-cart-panel]');
  var rendu = null; // element qui rendait la main au focus avant l'ouverture

  /* ------------------------------------------------------------------
     Ouverture et fermeture
     ------------------------------------------------------------------ */

  function ouvrir() {
    if (racine.classList.contains('is-open')) { return; }
    rendu = document.activeElement;
    /* Apres un ajout, poser() vient de recreer le panneau et le voile : le
       navigateur n'a encore calcule aucun style pour eux et sauterait la
       transition (tiroir affiche d'un coup, remarque du proprietaire du
       04/11/2026). Lire une dimension force ce calcul, position fermee
       comprise : le panneau glisse alors de la droite. */
    void panneau.offsetWidth;
    racine.classList.add('is-open');
    racine.setAttribute('aria-hidden', 'false');
    /* Bloque le defilement du fond : sur telephone, sans cela, le doigt
       fait defiler la page derriere le tiroir. */
    document.documentElement.classList.add('pl-cart-open');
    var premier = panneau.querySelector('[data-pl-cart-close]');
    if (premier && premier.focus) { premier.focus(); }
  }

  function fermer() {
    if (!racine.classList.contains('is-open')) { return; }
    racine.classList.remove('is-open');
    racine.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pl-cart-open');
    if (rendu && rendu.focus && document.contains(rendu)) { rendu.focus(); }
    rendu = null;
  }

  function occupe(etat) {
    racine.classList.toggle('is-busy', !!etat);
  }

  /* ------------------------------------------------------------------
     Rafraichissement : Shopify renvoie le tiroir entier, deja calcule.
     ------------------------------------------------------------------ */

  function racine_prefixe() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Pose le HTML rendu par Shopify. */
  function poser(html) {
    if (!html) { return false; }

    var tampon = document.createElement('div');
    tampon.innerHTML = html;
    var neuf = tampon.querySelector('[data-pl-cart]');
    if (!neuf) { return false; }

    /* On remplace l'interieur, pas la racine : la racine porte l'etat
       d'ouverture et les ecouteurs delegues. */
    var ouvert = racine.classList.contains('is-open');
    var avaitFocus = racine.contains(document.activeElement);
    racine.innerHTML = neuf.innerHTML;
    panneau = racine.querySelector('[data-pl-cart-panel]');
    if (ouvert) { racine.classList.add('is-open'); }
    /* Le tiroir est desormais ouvert avant la reponse (voir ajouterLignes) :
       le bouton qui avait le focus vient d'etre remplace, on le rend. */
    if (ouvert && avaitFocus) {
      var fermerBtn = panneau.querySelector('[data-pl-cart-close]');
      if (fermerBtn && fermerBtn.focus) { fermerBtn.focus({ preventScroll: true }); }
    }

    majCompteur();
    return true;
  }

  /* Les routes /cart/add.js, /cart/change.js et /cart/update.js acceptent
     toutes un champ `sections` et renvoient le HTML deja rendu dans la meme
     reponse. Un aller-retour au lieu de deux. */
  function poser_reponse(data) {
    if (data && data.sections && poser(data.sections[SECTION])) { return null; }
    return rafraichir();
  }

  /* Repli : quand la reponse ne portait pas de section. */
  function rafraichir() {
    return fetch(racine_prefixe() + '?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) { poser(data[SECTION]); });
  }

  /* Compteur de l'en-tete : lu depuis le tiroir fraichement rendu, donc
     depuis Shopify, jamais incremente a la main. */
  function majCompteur() {
    var source = racine.querySelector('.pl-cart__count');
    var total = source ? parseInt(source.textContent, 10) : 0;
    if (isNaN(total)) { total = 0; }
    document.querySelectorAll('.pl-header__cart-count').forEach(function (el) {
      el.textContent = total;
    });
  }

  /* ------------------------------------------------------------------
     Erreurs : affichees dans le tiroir, jamais avalees en silence.
     ------------------------------------------------------------------ */

  function signaler(message) {
    var zone = racine.querySelector('[data-pl-cart-error]');
    if (!zone) {
      zone = document.createElement('p');
      zone.className = 'pl-cart__error';
      zone.setAttribute('data-pl-cart-error', '');
      zone.setAttribute('role', 'alert');
      var tete = racine.querySelector('.pl-cart__head');
      if (tete && tete.parentNode) {
        tete.parentNode.insertBefore(zone, tete.nextSibling);
      } else {
        return;
      }
    }
    zone.textContent = message;
  }

  function echec(reponse) {
    return reponse.json().then(function (corps) {
      throw new Error(corps.description || corps.message || 'Something went wrong.');
    }, function () {
      throw new Error('Something went wrong.');
    });
  }

  /* ------------------------------------------------------------------
     Operations panier
     ------------------------------------------------------------------ */

  function ajouter(variantId, quantite) {
    return ajouterLignes([{ id: variantId, quantity: quantite || 1 }]);
  }

  /* Plusieurs lignes en un seul appel (bouton "Add all to basket" des
     ensembles par piece). */
  function ajouterLignes(lignes) {
    /* Le tiroir glisse des le toucher, avec un indicateur de chargement a la
       place du contenu, puis se remplit quand Shopify repond. Avant, il
       attendait la reponse (~0,5 a 1 s sans rien a l'ecran, remarque du
       proprietaire du 04/11/2026). */
    racine.classList.add('is-adding');
    occupe(true);
    ouvrir();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: lignes,
        sections: [SECTION]
      })
    })
      .then(function (r) { return r.ok ? r.json() : echec(r); })
      .then(poser_reponse)
      .then(ouvrir)
      .catch(function (e) { ouvrir(); signaler(e.message); })
      .finally(function () { racine.classList.remove('is-adding'); occupe(false); });
  }

  function changer(ligne, quantite) {
    occupe(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: ligne, quantity: quantite, sections: [SECTION] })
    })
      .then(function (r) { return r.ok ? r.json() : echec(r); })
      .then(poser_reponse)
      .catch(function (e) { signaler(e.message); })
      .finally(function () { occupe(false); });
  }

  /* ------------------------------------------------------------------
     Ecouteurs delegues sur la racine : le contenu est remplace a chaque
     rafraichissement, un ecouteur pose sur un bouton ne survivrait pas.
     ------------------------------------------------------------------ */

  racine.addEventListener('click', function (e) {
    var cible = e.target.closest('[data-pl-cart-close], [data-pl-cart-remove], [data-pl-cart-qty], [data-pl-cart-add], [data-pl-cart-uncode]');
    if (!cible) { return; }

    if (cible.hasAttribute('data-pl-cart-close')) {
      e.preventDefault();
      fermer();
      return;
    }

    if (cible.hasAttribute('data-pl-cart-remove')) {
      e.preventDefault();
      changer(parseInt(cible.getAttribute('data-pl-cart-remove'), 10), 0);
      return;
    }

    if (cible.hasAttribute('data-pl-cart-qty')) {
      e.preventDefault();
      var vers = parseInt(cible.getAttribute('data-pl-to'), 10);
      /* Descendre sous 1 retire la ligne : c'est ce que fait le bouton
         corbeille, et c'est ce que le client attend du bouton moins. */
      changer(parseInt(cible.getAttribute('data-pl-cart-qty'), 10), vers < 0 ? 0 : vers);
      return;
    }

    if (cible.hasAttribute('data-pl-cart-add')) {
      e.preventDefault();
      ajouter(cible.getAttribute('data-pl-cart-add'), 1);
      return;
    }

    if (cible.hasAttribute('data-pl-cart-uncode')) {
      e.preventDefault();
      var retire = cible.getAttribute('data-pl-cart-uncode');
      var form = racine.querySelector('[data-pl-cart-promo]');
      var restants = codes_poses(form).filter(function (c) { return c !== retire; });
      poser_codes(restants, form, null);
    }
  });

  /* ------------------------------------------------------------------
     Codes de reduction, sans rechargement.

     Le premier jet passait par /discount/CODE, qui pose le code sur la
     session puis redirige : toute la page se rechargeait, et le tiroir se
     refermait au passage. Corrige le 9 septembre 2026.

     `POST /cart/update.js` accepte un champ `discount` — les codes separes
     par des virgules — et renvoie `discount_codes`, chaque entree portant
     un drapeau `applicable`. C'est ce que fait `assets/cart-discount.js`
     d'Horizon. Deux consequences : plus de rechargement, et on peut dire au
     client que son code est refuse au lieu de le laisser devant un champ
     muet.

     Les codes deja poses sont renvoyes avec le nouveau : envoyer le seul
     dernier code effacerait les precedents.
     ------------------------------------------------------------------ */

  function poser_codes(codes, formulaire, code_teste) {
    occupe(true);
    return fetch(racine_prefixe() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: [SECTION] })
    })
      .then(function (r) { return r.ok ? r.json() : echec(r); })
      .then(function (data) {
        /* Shopify accepte la requete meme quand le code ne vaut rien : il
           faut lire le drapeau, sinon le champ se vide sans rien dire. */
        var refuse = false;
        if (code_teste && data && data.discount_codes) {
          data.discount_codes.forEach(function (d) {
            if (d.code === code_teste && d.applicable === false) { refuse = true; }
          });
        }

        var attendu = poser_reponse(data);
        if (!refuse) { return attendu; }

        /* Le message est pose APRES le rendu : `poser_reponse` remplace tout
           l'interieur du tiroir et effacerait un message ecrit avant lui. */
        return Promise.resolve(attendu).then(function () {
          signaler(message_erreur(formulaire));
        });
      })
      .catch(function (e) { signaler(e.message); })
      .finally(function () { occupe(false); });
  }

  function message_erreur(formulaire) {
    var champ = formulaire && formulaire.querySelector('input[name="code"]');
    return (champ && champ.getAttribute('data-error'))
      || 'That code cannot be applied to this basket.';
  }

  function codes_poses(formulaire) {
    var brut = formulaire ? (formulaire.getAttribute('data-pl-codes') || '') : '';
    return brut.split(',').map(function (c) { return c.trim(); })
      .filter(function (c) { return c.length > 0; });
  }

  racine.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pl-cart-promo]');
    if (!form) { return; }
    e.preventDefault();

    var champ = form.querySelector('input[name="code"]');
    var code = champ ? champ.value.trim() : '';
    if (!code) { return; }

    var codes = codes_poses(form);
    /* Deja pose : rien a envoyer, on vide juste le champ. */
    var deja = codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
    if (deja) { champ.value = ''; return; }

    codes.push(code);
    poser_codes(codes, form, code);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { fermer(); }
  });

  /* ------------------------------------------------------------------
     Branchement du reste du site
     ------------------------------------------------------------------ */

  /* Formulaires d'ajout au panier : fiche produit et barre d'achat
     collante. La detection se fait sur l'action du formulaire, pas sur un
     attribut : `{% form 'product' %}` poste toujours vers /cart/add, alors
     qu'un attribut pose sur la balise Liquid pourrait etre ignore au rendu
     et l'ajax ne partirait jamais sans qu'on le voie.
     `data-pl-cart-form` est conserve dans le Liquid comme repere de lecture
     et comme second filet.
     Sans ce script, ces formulaires postent normalement vers /cart. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form');
    if (!form) { return; }

    var versPanier = /\/cart\/add(\.js)?(\?|$)/.test(form.getAttribute('action') || '');
    if (!versPanier && !form.closest('[data-pl-cart-form]') && !form.hasAttribute('data-pl-cart-form')) {
      return;
    }
    e.preventDefault();

    var id = form.querySelector('[name="id"]');
    var qte = form.querySelector('[name="quantity"]');
    /* Ensemble : un champ `items[][id]` par produit. */
    var lignes = Array.prototype.map.call(form.querySelectorAll('[data-pl-cart-item]'), function (champ) {
      return { id: parseInt(champ.value, 10), quantity: parseInt(champ.getAttribute('data-quantity'), 10) || 1 };
    });
    if (!id && !lignes.length) { form.submit(); return; }

    var bouton = form.querySelector('button[type="submit"]');
    if (bouton) { bouton.classList.add('is-loading'); }

    var envoi = lignes.length ? ajouterLignes(lignes) : ajouter(id.value, qte ? parseInt(qte.value, 10) : 1);
    envoi.then(function () {
      if (bouton) { bouton.classList.remove('is-loading'); }
    });
  });

  /* Icone panier de l'en-tete : ouvre le tiroir au lieu d'aller sur /cart.
     Le lien reste un vrai lien : sans JavaScript, il mene a la page panier. */
  document.addEventListener('click', function (e) {
    var lien = e.target.closest('.pl-header__cart');
    if (!lien) { return; }
    /* Ctrl/Cmd-clic et clic molette : on laisse le navigateur ouvrir
       l'onglet, comme sur n'importe quel lien. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) { return; }
    e.preventDefault();
    ouvrir();
  });

  /* Ouverture depuis n'importe ou : `<a href="#" data-pl-cart-open>`. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pl-cart-open]')) {
      e.preventDefault();
      ouvrir();
    }
  });
})();
